import React, { useState, useEffect } from "react";
import styles from "./style.module.scss";
import JsonViewer from "../../Custom/JsonViewer";
import {
  EncryptionImport,
  EnergyManagementImport,
  StrategyImport,
} from "../../../types/imports";

interface FullImportViewProps {
  import: EnergyManagementImport | StrategyImport | EncryptionImport;
  onClose: () => void;
}

export default function FullImportView(props: FullImportViewProps) {
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchText), 300);
    return () => clearTimeout(timer);
  }, [searchText]);

  return (
    <div className={styles.modalOverlay} onClick={props.onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.searchContainer}>
          <input
            type="text"
            className={styles.searchInput}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search..."
            onClick={(e) => e.stopPropagation()}
          />
        </div>
        <div className={styles.jsonContainer}>
          <JsonViewer
            data={props.import}
            searchText={debouncedSearch}
            defaultExpanded={true}
            showFullBranchOnMatch={false}
          />
        </div>
      </div>
    </div>
  );
}
